import { TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import PropertyInputV2 from 'customer-data-properties/input/PropertyInputV2';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MoveToInboxPipelineAndStatus = ({
  properties,
  setPipelineInformation,
  pipelineInformation
}) => {
  const onChange = useCallback(propertyChanges => {
    const updatedProperties = {};
    Object.keys(propertyChanges).forEach(propertyName => updatedProperties[propertyName] = propertyChanges[propertyName] || '');
    setPipelineInformation(Object.assign({}, pipelineInformation, updatedProperties));
  }, [setPipelineInformation, pipelineInformation]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: (properties || []).map(property => /*#__PURE__*/_jsx(PropertyInputV2, {
      objectTypeId: TICKET_TYPE_ID,
      inputMode: "create",
      value: pipelineInformation[`${property.name}`] || '',
      property: property,
      getDraftValue: propertyName => pipelineInformation[propertyName] || '',
      getSavedValue: propertyName => pipelineInformation[propertyName] || '',
      enableConditionalPropertiesPanel: true,
      enableConditionalPropertyOptions: true,
      onChange: onChange,
      formControlProps: {
        label: property.label,
        required: true,
        'data-test-id': `${property.name}-input-property`
      }
    }, property.name))
  });
};
MoveToInboxPipelineAndStatus.displayName = 'MoveToInboxPipelineAndStatus';
export default MoveToInboxPipelineAndStatus;